import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _defineMessages;
import { defineMessages } from 'react-intl-next';
export var CommonMessage = /*#__PURE__*/function (CommonMessage) {
  CommonMessage["Project"] = "Project";
  CommonMessage["Search"] = "Search";
  CommonMessage["Add"] = "Add";
  CommonMessage["Cancel"] = "Cancel";
  CommonMessage["Edit"] = "Edit";
  CommonMessage["Submit"] = "Submit";
  CommonMessage["Create"] = "Create";
  CommonMessage["CreateAnother"] = "CreateAnother";
  CommonMessage["Copy"] = "Copy";
  CommonMessage["SubmitSave"] = "SubmitSave";
  CommonMessage["Save"] = "Save";
  CommonMessage["Saved"] = "Saved";
  CommonMessage["Close"] = "Close";
  CommonMessage["Reopen"] = "Reopen";
  CommonMessage["Change"] = "Change";
  CommonMessage["LoadingFormDetails"] = "LoadingFormDetails";
  CommonMessage["LoadingForm"] = "LoadingForm";
  CommonMessage["LoadingAvailableForms"] = "LoadingAvailableForms";
  CommonMessage["Loading"] = "Loading";
  CommonMessage["CreateForm"] = "CreateForm";
  CommonMessage["Download"] = "Download";
  CommonMessage["View"] = "View";
  CommonMessage["Next"] = "Next";
  CommonMessage["Prev"] = "Prev";
  CommonMessage["Showing"] = "Showing";
  CommonMessage["Of"] = "Of";
  CommonMessage["Upgrade"] = "Upgrade";
  CommonMessage["Delete"] = "Delete";
  CommonMessage["And"] = "And";
  CommonMessage["Export"] = "Export";
  CommonMessage["Back"] = "Back";
  CommonMessage["Templates"] = "Templates";
  CommonMessage["All"] = "All";
  CommonMessage["Xlsx"] = "Xlsx";
  CommonMessage["Json"] = "Json";
  return CommonMessage;
}({});
export var IntlCommonMessages = defineMessages((_defineMessages = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineMessages, CommonMessage.Project, {
  id: 'form-system.general.Project',
  defaultMessage: 'Project'
}), CommonMessage.Search, {
  id: 'form-system.general.Search',
  defaultMessage: 'Search'
}), CommonMessage.Cancel, {
  id: 'form-system.general.Cancel',
  defaultMessage: 'Cancel'
}), CommonMessage.Add, {
  id: 'form-system.general.Add',
  defaultMessage: 'Add'
}), CommonMessage.Edit, {
  id: 'form-system.general.Edit',
  defaultMessage: 'Edit'
}), CommonMessage.Submit, {
  id: 'form-system.general.Submit',
  defaultMessage: 'Submit'
}), CommonMessage.Create, {
  id: 'form-system.general.Create',
  defaultMessage: 'Create'
}), CommonMessage.CreateAnother, {
  id: 'form-system.general.CreateAnother',
  defaultMessage: 'Create another'
}), CommonMessage.Copy, {
  id: 'form-system.general.Copy',
  defaultMessage: 'Copy'
}), CommonMessage.SubmitSave, {
  id: 'form-system.general.SubmitSave',
  defaultMessage: 'Save and submit'
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineMessages, CommonMessage.Save, {
  id: 'form-system.general.Save',
  defaultMessage: 'Save'
}), CommonMessage.Saved, {
  id: 'form-system.general.Saved',
  defaultMessage: 'Saved'
}), CommonMessage.Close, {
  id: 'form-system.general.Close',
  defaultMessage: 'Close'
}), CommonMessage.Reopen, {
  id: 'form-system.general.Reopen',
  defaultMessage: 'Reopen'
}), CommonMessage.Change, {
  id: 'form-system.general.Change',
  defaultMessage: 'Change'
}), CommonMessage.LoadingFormDetails, {
  id: 'form-system.general.LoadingFormDetails',
  defaultMessage: 'Loading form details'
}), CommonMessage.LoadingForm, {
  id: 'form-system.general.LoadingForm',
  defaultMessage: 'Loading form'
}), CommonMessage.LoadingAvailableForms, {
  id: 'form-system.general.LoadingAvailableForms',
  defaultMessage: 'Loading available forms'
}), CommonMessage.Loading, {
  id: 'form-system.general.Loading',
  defaultMessage: 'Loading'
}), CommonMessage.CreateForm, {
  id: 'form-system.general.CreateForm',
  defaultMessage: 'Create Form'
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineMessages, CommonMessage.Download, {
  id: 'form-system.general.Download',
  defaultMessage: 'Download'
}), CommonMessage.View, {
  id: 'form-system.general.View',
  defaultMessage: 'View'
}), CommonMessage.Next, {
  id: 'form-system.general.Next',
  defaultMessage: 'Next'
}), CommonMessage.Prev, {
  id: 'form-system.general.Prev',
  defaultMessage: 'Prev'
}), CommonMessage.Showing, {
  id: 'form-system.general.Showing',
  defaultMessage: 'Showing'
}), CommonMessage.Of, {
  id: 'form-system.general.Of',
  defaultMessage: 'of'
}), CommonMessage.Upgrade, {
  id: 'form-system.general.Upgrade',
  defaultMessage: 'Upgrade'
}), CommonMessage.Delete, {
  id: 'form-system.general.Delete',
  defaultMessage: 'Delete'
}), CommonMessage.And, {
  id: 'form-system.general.And',
  defaultMessage: 'And'
}), CommonMessage.Export, {
  id: 'form-system.general.Export',
  defaultMessage: 'Export'
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineMessages, CommonMessage.Back, {
  id: 'form-system.general.Back',
  defaultMessage: 'Back'
}), CommonMessage.Templates, {
  id: 'form-system.general.Templates',
  defaultMessage: 'Templates'
}), CommonMessage.All, {
  id: 'form-system.general.All',
  defaultMessage: 'All'
}), CommonMessage.Xlsx, {
  id: 'form-system.general.Xlsx',
  defaultMessage: 'XLSX'
}), CommonMessage.Json, {
  id: 'form-system.general.Json',
  defaultMessage: 'JSON'
})));